import axios from 'axios'

export const getByStatus = (params) => {
  return axios.get('dashboard/shipments/statuses', {params: params})
}

export const getByTime = (params) => {
  return axios.get('dashboard/shipments/statuses/by-time', {params: params})
}

export const getByCarrier = (params) => {
  return axios.get('statistics/shipments/carriers', {params: params})
}

export const getByCarrierPie = (params) => {
  return axios.get('statistics/shipments/carriers-pie', {params: params})
}

export const getClientByDay = (params) => {
  return axios.get('dashboard/clients', {params: params})
}

export const getTop10User = (params) => {
  return axios.get('statistics/top-10-user', {params: params})
}

export const getProportion = (params) => {
  return axios.get('statistics/proportion', {params: params})
}

export const getProportionPie = (params) => {
  return axios.get('statistics/proportion/pie', {params: params})
}

export const getTotalCod = (params) => {
  return axios.get('statistics/total-cod-amount', {params: params})
}

export const getProfit = (params) => {
  return axios.get('statistics/total-profit', {params: params})
}

export const getTotalShop = (params) => {
  return axios.get('statistics/total-shop', {params: params})
}

export const getTotalSource = (params) => {
  return axios.get('statistics/total-source', {params: params})
}

export const getAllUserHasShipments = (params) => {
  return axios.get('statistics/all-user-has-shipments', {params: params})
}

export const getTop10DistrictTopShipment = (params) => {
  return axios.get('statistics/top-10-district-shipment', {params: params})
}

export const getTop10DistrictTopUser = (params) => {
  return axios.get('statistics/top-10-district-user', {params: params})
}

export const getMatrixShipmentByCity = (params) => {
  return axios.get('statistics/matrix-shipment-by-city', {params: params})
}

export const getInterprovinceShipment = (params) => {
  return axios.get('statistics/interprovince-shipment', {params: params})
}

export const getAllShipmentFromCity = (params) => {
  return axios.get('statistics/all-shipment-from-city', {params: params})
}



// WEBPACK FOOTER //
// ./src/api/dashboard.js